/**
 * Normalización de texto para COMPARAR (nombres, áreas, oficinas, headers de
 * planillas). Una sola implementación: la auditoría del 18/09/2026 encontró 15
 * copias de "sacar tildes y bajar a minúsculas" con tres semánticas distintas
 * — solo 4 colapsaban espacios internos, así que "Juan  Pérez" (doble espacio,
 * típico de copy-paste en el community map) no matcheaba el índice de líderes
 * construido con `${name} ${lastName}`.
 *
 * Pura, sin dependencias: la usan backend, frontend y `shared/`.
 * Tests: `npm run test:text-normalize`.
 */

/** Sin tildes ni diacríticos, minúsculas, trim. Respeta el espaciado interno. */
export function deaccentRaw(s: string | null | undefined): string {
  return (s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); // reuse-ok: ESTA es la implementación compartida
}

/**
 * Clave canónica para comparar personas/áreas/valores: sin tildes, minúsculas,
 * espacios internos colapsados a uno, trim. Es lo que hay que usar para
 * indexar y buscar; `deaccentRaw` solo cuando el espaciado importa.
 */
export function foldKey(s: string | null | undefined): string {
  return deaccentRaw(s).replace(/\s+/g, ' ');
}

/** ¿Son la misma cosa escrita distinto? (tildes, mayúsculas, espacios) */
export function sameKey(a: string | null | undefined, b: string | null | undefined): boolean {
  return foldKey(a) === foldKey(b);
}

/**
 * Slug para un id a partir de un nombre ("Rappitenderos (RTs)" → "rappitenderos-rts"): sin tildes,
 * minúsculas, guiones, tope `max`. Un solo lugar (19/10/2026): ids de clientes y BUs del Brain.
 */
export function slugify(s: string | null | undefined, max = 60): string {
  return deaccentRaw(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, max).replace(/-+$/, '');
}
